import { AnimatedView } from '@/components/ui/animated';
import React, { useEffect, useState } from 'react';
import { View } from 'react-native';
import { Easing, useAnimatedStyle, useSharedValue, withTiming } from 'react-native-reanimated';

/**
 * Bloco que abre e fecha animando a altura medida (padrão collapse-reveal).
 * O conteúdo fica sempre montado — no HTML estático a resposta está no DOM,
 * só recortada — então buscador e IA leem tudo sem JavaScript.
 */
export function Disclosure({ open, children }: { open: boolean; children: React.ReactNode }) {
  const [contentHeight, setContentHeight] = useState(0);
  const progress = useSharedValue(open ? 1 : 0);

  useEffect(() => {
    progress.value = withTiming(open ? 1 : 0, {
      duration: open ? 260 : 220,
      easing: Easing.inOut(Easing.ease),
    });
  }, [open, progress]);

  const style = useAnimatedStyle(() => ({
    height: progress.value * contentHeight,
    opacity: progress.value,
  }));

  return (
    <AnimatedView style={style} className="overflow-hidden">
      <View
        style={{ position: 'absolute', left: 0, right: 0 }}
        onLayout={(e) => {
          const h = e.nativeEvent.layout.height;
          if (h > 0 && Math.abs(h - contentHeight) > 0.5) setContentHeight(h);
        }}
      >
        {children}
      </View>
    </AnimatedView>
  );
}
